import React, { useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { AiOutlineLogout} from "react-icons/ai";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { IoIosNotifications } from "react-icons/io";
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdQuestionAnswer } from "react-icons/md";
import { getEnquiries } from "../features/enquiry/enquirySlice";
import { BiSolidCalendarEvent } from "react-icons/bi";
import { getBookings } from "../features/booking/bookingSlice";
import { RiUserLocationFill } from "react-icons/ri";
import { TbWorldCheck } from "react-icons/tb";
import { TbWorldWww } from "react-icons/tb";
import { TbWorldStar } from "react-icons/tb";


const { Header, Sider, Content } = Layout;


const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  useEffect(() => {
    dispatch(getEnquiries());
    dispatch(getBookings());
   
    const interval = setInterval(() => {
      dispatch(getEnquiries());
      dispatch(getBookings());
     }, 50000);
  
    return () => clearInterval(interval);
  }, [dispatch]);
  
  
    const unreadEnquiriesCount = useSelector(state => state?.enquiry?.enquiries?.filter(e => !e.read)?.length || 0);
    const unreadBookingsCount = useSelector(state => state?.booking?.bookings?.filter(e => !e.read)?.length || 0);

   const totalUnreadCount =unreadBookingsCount  + unreadEnquiriesCount;
   const {
    token: { colorBgContainer },
  } = theme.useToken();

 
 
 

  
  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo">
          <h2 className="text-white fs-5 text-center py-3 mb-0">
            <span className="sm-logo">R.K</span>
            <span className="lg-logo">Roarz Kreatives</span>
          </h2>
        </div>
        <Menu
          theme="dark"
          className="menu-wrapper"
          mode="inline"
          defaultSelectedKeys={[""]}
          onClick={({ key }) => {
            if (key === "signout") {
              localStorage.clear()
              window.location.reload()
            } else {
              navigate(key);
            }
          }}
          items={[

             {
              key: "online-visitors",
              icon: <RiUserLocationFill className="fs-4" />,
              label: "Online Visitors",
            },
                      
              {
                key: "Projects",
                icon: <TbWorldWww className="fs-4" />,
                label: "Projects",
                children: [
               
             
                {
                  key: "add-project",
                  icon: <TbWorldCheck className="fs-4" />,
                  label: "Add Project",
                }, 
                {
                  key: "projects-list",
                  icon: <TbWorldStar className="fs-4" />,
                  label: "Projects List",
                },        
      
  
                ],
              },
               {
                key: "bookings",
                icon: 
                (
                  <div className="position-relative">
                  <BiSolidCalendarEvent className="fs-4" />
                  {unreadBookingsCount > 0 && (
                 <span className=" bg-danger rounded-circle position-absolute" style={{ top: 0, right: 0, width: 8, height: 8 }}></span>

                  )}
                  </div>
                ),

                label: "Event Bookings",
              },
 
            {
              key: "enquiries",
              icon: (
                <div className="position-relative">
                  <MdQuestionAnswer className="fs-4" />
                  {unreadEnquiriesCount > 0 && (
                    <span className=" bg-danger rounded-circle position-absolute" style={{ top: 0, right: 0, width: 8, height: 8 }}></span>
                  )}
                </div>
              ),
              label: "Enquiries",
            },
    
            {
              key: "signout",
              icon: <AiOutlineLogout className="fs-4" />,
              label: "Sign Out",
            },
          ]}
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="d-flex justify-content-between ps-1 pe-5"
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}
          <div className="d-flex gap-4 align-items-center">
          <div className="position-relative"  >
          <IoIosNotifications className="fs-4" />
          {totalUnreadCount > 0 && (
        <span className="badge bg-warning rounded-circle p-1 position-absolute" style={{ zIndex: 1 }}>
          {totalUnreadCount}
        </span>
      )}
             </div>

            <div className="d-flex gap-3 align-items-center dropdown">
              <div>
           
              </div>
         
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                  >
                    View Profile
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                  >
                    Signout
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <ToastContainer
            position="top-right"
            autoClose={250}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="light"
          />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
